<template>
  <div v-loading="isLoadingMarkEssay">
    <h3>{{title}}</h3>
    <hr>
    <div class="p-8 rounded-lg d-flex" style="background: #f9f7fb; align-items: center;">
      <div class="row w-100">
        <div class="d-flex col-md-4">
          <span class="font-weight-bold" style="min-width: 100px">Học viên: </span>
          <b>{{ mark_essay?.student?.name }}</b>
        </div>
        <div class="d-flex col-md-4 my-3 my-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Số điện thoại:</span>
          <b>{{ mark_essay?.student?.phone }}</b>
        </div>
        <div class="d-flex col-md-4 mb-3 mb-md-0">
          <span class="font-weight-bold" style="min-width: 100px">Buổi học:</span>
          <b>{{ lesson }}</b>
        </div>
      </div>
    </div>
    <div class="rounded-lg mt-5">
<!--      <CommentAnswer v-if="answerOfStudent.length > 0 && !isCambridgeMentor()"-->
<!--          :type="type"-->
<!--          :group-questions="answerOfStudent"-->
<!--          :typeMark="score_max_homework"-->
<!--          :course_student_id="course_student_id"-->
<!--          :order="order"-->
<!--      />-->
      <MakeHomeworkContainer v-if="answerOfStudent.length > 0 && !isCambridgeMentor()"
          :group-questions="answerOfStudent"
          :typeCourse="score_max_homework"
          :course_student_id="course_student_id"
          :type="type"
          :order="order"
          :overall_id="overall_id"
      />
     <CommentAnswerKid v-if="answerOfStudent.length > 0 && isCambridgeMentor()"
      :type="type"
      :group-questions="answerOfStudent"
      :typeMark="score_max_homework"
      :course_student_id="course_student_id"
      :order="order"
     >
     </CommentAnswerKid>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADMIN_GET_MARK_HOMEWORK_V2,
  ADMIN_HOMEWORK_V2,
} from "@/core/services/store/course/classes.module";
import { INSPECTION_GET_MARK } from "@/core/services/store/inspection/inspection.module";
import moment from "moment-timezone";
import CommentAnswer from "./components/CommentAnswer.vue";
import {AnswerStudent} from "@/view/pages/classes/model/AnswerStudent";
import {Cambridge_Mentor_ID} from "@/core/option/typeCenterBill";
import CommentAnswerKid from "@/view/pages/classes/components/CommentAnswerKid.vue";
import { RECORD_VIDEO, RECORD_AUDIO} from "./mark-homework/constant";
import MakeHomeworkContainer from "./mark-homework/MakeHomeworkContainer.vue";
import {GET_EXAM_MARK_TUTOR} from "../../../core/services/store/course/classes.module";

export default {
  components: {CommentAnswerKid, CommentAnswer, MakeHomeworkContainer },
  data() {
    return {
      isLoadingMarkEssay: true,
      mark_essay: {
        student: {},
        data: [],
      },
      lesson: null,
      classroom_id: null,
      student_id: null,
      course_student_id: null,
      time_send_homework: null,
      loading: false,
      score_max_homework: 0,
      answerOfStudent: [],
      type : '',
      order : null,
      RECORD_VIDEO,
      RECORD_AUDIO,
      overall_id: null,
    }
  },
  computed: {
    title() {
      return this.type === 'remark-inspection' ? 'Chấm lại bài tập về nhà' : 'Chấm điểm bài tập về nhà lần 2';
    }
  },
  async mounted() {
    this.type = this.$route.query.typeReMark == 'remark-inspection' ? 'remark-inspection' : this.$route.query.typeReMark == 'remark-tutor' ? 'remark-tutor' : 'remark-lib';
    this.order = this.$route.query.order;
    this.lesson = this.$route.query.lesson;
    this.classroom_id = this.$route.query.classroom_id
    this.student_id = this.$route.query.student_id
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý lớp học", route: 'schedule-class', id: this.$route.query.classroom_id },
      { title: this.title }
    ]);
    await this.getMarkStudent()
  },
  methods: {
    defaultSpeakingEvaluation() {
      return {
        evaluationStatus: 'pass',
        notMeetReason: '',
        notMeetDescription: ''
      }
    },
    getMarkStudent() {
      this.$store.dispatch(ADMIN_HOMEWORK_V2, {
        classroom_id: this.classroom_id,
        lesson: this.lesson,
        type: 'homework',
        user_id: this.student_id
      }).then((res) => {
        if (!res.error) {
          if (res.data.length > 0) {
            this.mark_essay.student = res.data[0];
            this.score_max_homework = res.data[0].score_max_homework
            this.course_student_id = res.data[0].course_student_id
            this.overall_id = res.data[0].test?.overall_id
            const basePayload = {
              classroom_id: this.classroom_id,
              overall_id: res.data[0].test?.overall_id,
            }

            const payload = this.type === 'remark-tutor' ?
                    {
                      ...basePayload,
                      lesson: this.$route.query.lesson,
                      student_id: this.$route.query.student_id,
                    } : {
                      ...basePayload,
                      course_student_id: res.data[0].course_student_id,
                      id: this.$route.query.inspection_id,
                    }
            const url_dispatch = this.type == 'remark-inspection' ? INSPECTION_GET_MARK : this.type === 'remark-tutor' ? GET_EXAM_MARK_TUTOR : ADMIN_GET_MARK_HOMEWORK_V2;
            this.$store.dispatch(url_dispatch, payload).then((res) => {
              if (!res.error) {
                this.mark_essay.data = this.type == 'remark-inspection' ? [res.data] : res.data;
                const processedHomework = this.mark_essay?.data.map((e)=>{
                  let typeAnswer = e?.group_question?.type
                 return  new AnswerStudent(e.comment,e.comments,e.group_question,e.outcomes_id,e.overall_result_id,e.score,e.score_detail,e.status_mark,e.student_answer,e.test_id,e.type,e.user_id,typeAnswer)
                })
                this.answerOfStudent = this.transformGroupSpeaking(processedHomework)
                this.isLoadingMarkEssay = false;
              }
            }).catch((e) => {
              console.log(e, 'error')
            }).finally(() => {
              this.isLoadingMarkEssay = false;
            });
            this.time_send_homework = moment(this.mark_essay.student.test.created_at).format('HH:mm:ss YYYY-MM-DD')
          }
        }
      }).catch((e) => {
        console.log(e, 'error')
      });
    },
    isCambridgeMentor() {
      const idCenter = this.$route.query.center_id;
      return +idCenter === Cambridge_Mentor_ID
    },
    // tranform group speaking
    transformGroupSpeaking(processedHomework) {
      // Group speaking homework items together
      const groupedHomework = []
        const speakingItems = []

        processedHomework?.forEach((homework) => {
          if ([RECORD_VIDEO, RECORD_AUDIO].includes(homework?.typeAnswer)) {
            speakingItems.push(homework)
          } else {
            groupedHomework.push(homework)
          }
        })

        // Add grouped speaking items if any exist
        if (speakingItems.length > 0) {
          groupedHomework.push({
            type_group: "speaking",
            data: speakingItems,
            speakingEvaluation: this.defaultSpeakingEvaluation(),
            evaluations: {
              fluency: { score: null, comment: null },
              vocabularyRange: { score: null, comment: null },
              grammaticalRange: { score: null, comment: null },
              pronunciation: { score: null, comment: null }
            },
          })
        }
        return groupedHomework;
    },
  },

}
</script>

<style lang="scss" scoped>
.btn-custom {
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  align-self: center;

  :hover {
    background-color: burlywood;
  }
}
</style>